import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import dayjs from 'dayjs';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import { IInAppProps, ICoupon } from 'utils/types/saleTypes';
import { PublicStateEnhance } from 'utils/constant';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import MainTable from 'components/table/MainTable';
import NoImage from 'components/etc/NoImage';
import TextButton from 'components/button/TextButton';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
import { IProject } from '../../../utils/types/storyTypes';
import { productApis } from '../../../apis/package/productApis';
import { FaApple } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import InAppRegisterModal from './InAppRegisterModal';
import { Trash } from 'iconsax-react';
import DeleteModal from '../../../components/modal/DeleteModal';

/**
 * * 판매 - 인앱 상점 관리 - 목록
 */

interface IProps {
  selectProject: IProject;
}

const InAppStoreListPage = ({ selectProject }: IProps) => {
  const { t } = useTranslation();
  const { id, masterId } = useParams();

  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState();
  const [products, setProducts] = useState<ICoupon[]>([]);
  const [visible, setVisible] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<ICoupon>();

  const handleLink = (product) => (e) => {
    navigate(`/inStore/${selectProject.project_id}/${product.master_id}`, {
      state: { product: product, selectProject: selectProject },
    });
  };

  const handleClickDeleteModal = (product: ICoupon) => {
    setSelectedProduct(product);
    setDeleteModalOpen(true);
  };

  const fetchData = async () => {
    const res = await productApis.productList(selectProject.project_id);
    setProducts(res.products);
  };

  const columnOrigin = [
    {
      title: t('ifYou.table.productID'),
      align: 'center',
      width: '6rem',
      dataIndex: 'master_id',
      sorter: (a, b) => a.master_id - b.master_id,
    },
    {
      title: t('ifYou.table.productURL'),
      dataIndex: 'product_url',
      width: '6rem',
      align: 'center',
      render: (_, record: ICoupon) => {
        const lang = cookies.lang ? cookies.lang : 'KO';
        // find banner_url by lang
        let langObject = record.langs.find((obj) => obj.lang === lang);

        if (!langObject?.banner_url) {
          langObject = record.langs.find((lang) => lang.banner_key !== null);
        }

        return langObject?.banner_url ? (
          <Image
            src={langObject.banner_url}
            height={80}
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <NoImage />
        );
      },
    },
    {
      title: t('ifYou.table.productName'),
      dataIndex: 'product_name',
      width: '11rem',
      render: (text, record: ICoupon) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('ifYou.table.productType'),
      dataIndex: 'product_type',
      width: '7rem',
      render: (text, record: ICoupon) => (
        <div>{record.product_type === 'base' ? '일회성' : '영구적'}</div>
      ),
    },
    {
      title: 'OS',
      dataIndex: 'os_type',
      width: '5rem',
      render: (text, record: ICoupon) => {
        const os =
          record.os_type === 'all'
            ? 'all'
            : record.os_type === 'iOS'
            ? 'iOS'
            : 'Android';
        return <div>{os}</div>;
      },
    },
    {
      title: t('ifYou.table.action'),
      width: '10rem',
      align: 'center',
      render: (_, record: ICoupon) => {
        return (
          <div>
            <Trash
              size='24'
              onClick={() => {
                handleClickDeleteModal(record);
              }}
            />
          </div>
        );
      },
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    await productApis.deleteProduct(
      selectProject.project_id,
      selectedProduct!.master_id,
    );
    fetchData();
    setDeleteModalOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchData().catch(console.log);
  }, [selectProject]);

  return (
    <>
      <TableToolbar>
        <SearchInput
          setSearchData={setSearchData}
          placeholder={t('ifYou.header.inputPlaceHolder')}
        />
        <div>
          <DefaultButton
            name='register'
            onClick={() => setVisible(true)}
            disabled={false}
          >
            {t('ifYou.header.registerButton')}
          </DefaultButton>
          {/*<DefaultButton*/}
          {/*  name="deploy"*/}
          {/*  onClick={handleOpen}*/}
          {/*  disabled={false}*/}
          {/*  backColor={`${theme.colors.server_orange}`}*/}
          {/*>*/}
          {/*  {t('ifYou.header.liveButton')}*/}
          {/*</DefaultButton>*/}
        </div>
      </TableToolbar>

      <MainTable columns={columnOrigin} dataSource={products} />

      <InAppRegisterModal
        visible={visible}
        setVisible={setVisible}
        fetchData={fetchData}
      />

      <DeleteModal
        visible={deleteModalOpen}
        setVisible={setDeleteModalOpen}
        title={'인앱상품 삭제'}
        content={''}
        label={selectedProduct?.product_name}
        handleDelete={handleDelete}
        loading={loading}
      />

      {/*<DeployModal*/}
      {/*  title={t('ifYou.modal.title')}*/}
      {/*  kind="product"*/}
      {/*  visible={deployModalOpen}*/}
      {/*  setVisible={setDeployModalOpen}*/}
      {/*  fetchData={fetchData}*/}
      {/*/>*/}
    </>
  );
};

export default InAppStoreListPage;
